export default __webpack_public_path__ + "static/media/640_portfolio04-es-mobile.82c8e3d8.png";